import { BehaviorSubject } from "rxjs";
import { LoginAPICalls } from "./ApiService";
import utils from "../utils/utils";
import CryptoJS from "crypto-js";

const currentUserSubject = new BehaviorSubject();
const mfaUserSubject = new BehaviorSubject();
const pwdUserSubject = new BehaviorSubject();
const fpUserSubject = new BehaviorSubject();
const fpvUserSubject = new BehaviorSubject();

let userLoggedIn = false;
let mfaUserLoggedIn = false;
let pwdUserLoggedIn = false;

export const authenticationService = {
  submitforgotPassVerfication,
  login,
  checkRegistrationToken,
  logout,
  isLoggedin,
  forgetPass,
  reauthenticate,
  submit2fa,
  changeNewPassword,
  resetPassword,
  currentSessionToken,
  userLoggedIn,
  mfaUserLoggedIn,
  pwdUserLoggedIn,
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() {
    return currentUserSubject.value;
  },
  currentfpUser: fpUserSubject.asObservable(),

  get currentfpUserValue() {
    return fpUserSubject.value;
  },
  currentfpvUser: fpvUserSubject.asObservable(),

  get currentfpvUserValue() {
    return fpvUserSubject.value;
  },

  currentMfaUser: mfaUserSubject.asObservable(),

  get currentMfaUserValue() {
    return mfaUserSubject.value;
  },
  pwdUser: pwdUserSubject.asObservable(),

  get pwdUserValue() {
    return pwdUserSubject.value;
  },
};

async function checkTokenRole(token) {
  // console.log("REACT_APP_AES_KEY:", process.env.REACT_APP_AES_KEY);

  try {
    const decryptedToken = (
      await CryptoJS.AES.decrypt(token, process.env.REACT_APP_AES_KEY)
    ).toString(CryptoJS.enc.Utf8);

    // If decryption fails or returns empty string, assume token is not encrypted
    if (!decryptedToken) {
      console.warn("Token decryption returned empty string, using token as-is");
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        window
          .atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      return JSON.parse(jsonPayload);
    }

    const base64Url = decryptedToken.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Error decrypting token, attempting to parse as plain JWT:", error);
    // If decryption fails, try to parse the token as a plain JWT
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        window
          .atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      return JSON.parse(jsonPayload);
    } catch (innerError) {
      console.error("Failed to parse token as JWT:", innerError);
      throw new Error("Invalid token format");
    }
  }
}

async function checkRegistrationToken(token) {
  let response = await LoginAPICalls.checkTokenExpiry(token);
  return response;
}

async function login(email, password, recaptchaValue) {
  let response = await LoginAPICalls.signIn(email, password, recaptchaValue);
  if (response && response.status < 400) {
    let data = response.data;
    let token = data.token;
    let decodedToken = await checkTokenRole(token);
    if (decodedToken.role !== data.role) {
      data.role = decodedToken.role;
      response.data.role = decodedToken.role;
    }
    currentUserSubject.next(data);
    sessionStorage.setItem("loggedInUser", JSON.stringify(data));
    sessionStorage.setItem("userLoggedIn", String(true));

    // utils.set(data,'status','pass')
    // utils.set(data,'updatePassword',true)
    if (
      data &&
      data.hasOwnProperty("status") &&
      String(data["status"]).toLowerCase() === "2fa"
    ) {
      mfaUserLoggedIn = true;
      mfaUserSubject.next(data);
    } else if (
      data &&
      data.hasOwnProperty("status") &&
      String(data["status"]).toLowerCase() === "PASS"
    ) {
      if (
        data.hasOwnProperty("updatePassword") &&
        data["updatePassword"] === true
      ) {
        pwdUserSubject.next(data);
        pwdUserLoggedIn = true;
      } else {
        userLoggedIn = true;
        currentUserSubject.next(data);
      }
    }
  }

  return response;
}

async function submit2fa(mfaCode) {
  debugger;
  let data = await LoginAPICalls.submit2fa(mfaCode); // already payload
  if (!data) return null;

  let token = data.token;
  let decodedToken = await checkTokenRole(token);
  if (decodedToken.role !== data.role) {
    data.role = decodedToken.role;
  }

  sessionStorage.clear();
  currentUserSubject.next(data);
  sessionStorage.setItem("loggedInUser", JSON.stringify(data));
  sessionStorage.setItem("userLoggedIn", String(true));

  if (String(data.status || "").toLowerCase() === "pass") {
    if (data.updatePassword === true) {
      pwdUserSubject.next(data);
      pwdUserLoggedIn = true;
    } else {
      userLoggedIn = true;
      currentUserSubject.next(data);
    }
    mfaUserSubject.next(null);
    mfaUserLoggedIn = false;
  }

  return data;
}

async function submitforgotPassVerfication(mfaCode) {
  let response = await LoginAPICalls.submitForgotPasswordCode(mfaCode);
  if (response.status < 400) {
    let data = response.data;
    currentUserSubject.next(data);
    sessionStorage.setItem("userLoggedIn", String(false));
  }

  return response;
}

async function forgetPass(email, recaptchaValue) {
  let response = await LoginAPICalls.forgetPass(email, recaptchaValue);

  if (response.status < 400) {
    let data = response.data;
    await fpUserSubject.next(data);
    sessionStorage.setItem("fpUserLoggedIn", String(false));
    sessionStorage.setItem("userLoggedIn", String(false));
  }

  return response;
}

function reauthenticate() {
  let data = JSON.parse(sessionStorage.getItem("loggedInUser"));
  sessionStorage.setItem("userLoggedIn", String(true));
  currentUserSubject.next(data);
}

function isLoggedin() {
  return Boolean(
    sessionStorage.getItem("userLoggedIn") === "true" &&
      sessionStorage.getItem("loggedInUser") !== "undefined"
  );
}

async function changeNewPassword(password) {
  let response = await LoginAPICalls.changeNewPassword(password);
  if (response && response.status < 400) {
    let data = response.data;
    sessionStorage.setItem("loggedInUser", JSON.stringify(data));
    sessionStorage.setItem("userLoggedIn", String(true));

    if (
      data &&
      data.hasOwnProperty("status") &&
      String(data["status"]).toLowerCase() === "pass"
    ) {
      userLoggedIn = true;
      currentUserSubject.next(data);
    }
  }

  return response;
}

async function currentSessionToken() {
  let user = JSON.parse(JSON.stringify(currentUserSubject["value"]));
  let currentToken = user["token"];
  let refreshToken = user["refreshToken"];
  let decodedToken = utils.parseJwt(currentToken);
  // let exp = (decodedToken['exp']) * 1000
  // let curTime = (new Date()).getTime()
  // let tokenExpired = curTime - exp > 0
  // return new Promise(async (resolve, reject) => {
  //     if (tokenExpired) {
  //         await refreshToken(refreshToken).then(async token => {
  //             //set new token to user
  //             user['token'] = token
  //             await currentUserSubject.next(user);
  //             sessionStorage.setItem('loggedInUser', JSON.stringify(user))
  //             resolve(token)
  //         }).catch(e => {
  //             console.error(e);
  //             reject(e);
  //         })
  //     } else {
  //         resolve(currentToken)
  //     }
  //
  // });
  return currentToken;
}

async function resetPassword(email, reCaptchaToken) {
  return await LoginAPICalls.resetPassword(email, reCaptchaToken);
}

function logout() {
  console.log("logout");
  document.getElementById("root").click();
  userLoggedIn = false;
  currentUserSubject.next(null);
  sessionStorage.clear();
  localStorage.clear()
}
